@if (form) {
    <ng-container [formGroup]="form">
        <td class="cutter-selection" [class.empty]="!selectedMill" [matTooltip]="selectedMill?.name">
            <div class="showname">{{ selectedMill?.name }}</div>
            <input
                class="row-input"
                #millInput
                [matAutocomplete]="autoCompleteMill"
                autocomplete="off"
                formControlName="asphaltmill_id"
                placeholder="Molen"
                type="text" />
            <mat-autocomplete
                #autoCompleteMill="matAutocomplete"
                [displayWith]="emptystring"
                [panelWidth]="300"
                (optionSelected)="millSelectionChange($event)"
                autoActiveFirstOption>
                @for (mill of filteredMills | async; track mill) {
                    <mat-option
                        [class.mat-active]="selectedMill == mill"
                        [disabled]="!mill.asphalt || mill.asphalt.length === 0"
                        [value]="mill">
                        {{ mill.name }}
                    </mat-option>
                }
            </mat-autocomplete>
        </td>
        <td
            class="cutter-selection"
            [class.empty]="!asphaltText || asphaltText.length === 0"
            [class.info]="
                form.get('asphaltname')?.value &&
                (!selectedAsphalt || form.get('asphaltname').value !== selectedAsphalt.asphalt.name)
            "
            [matTooltip]="asphaltText ? asphaltText : ('asphalttype' + (selectedMill ? '' : '-nomill') | tt)">
            <div class="showname">{{ asphaltText }}</div>
            <input
                class="row-input"
                #asphaltInput
                [matAutocomplete]="autoCompleteAsphalt"
                (change)="asphaltTextChanged($event)"
                autocomplete="nofill"
                formControlName="asphaltname"
                placeholder="Zoek naar asfalt..."
                type="text" />
            <mat-autocomplete
                #autoCompleteAsphalt="matAutocomplete"
                [displayWith]="emptystring"
                [panelWidth]="350"
                (optionSelected)="asphaltSelectionChange($event)"
                autoActiveFirstOption>
                @if (selectedMill) {
                    @for (asphalt of filteredAsphalt | async; track asphalt) {
                        <mat-option [value]="asphalt"> ({{ asphalt.code }}) {{ asphalt.asphalt.name }} </mat-option>
                    }
                }
            </mat-autocomplete>
        </td>
        <td
            class="number-input"
            [class.info]="
                form.get('asphaltcode')?.value &&
                (!selectedAsphalt || form.get('asphaltcode').value !== selectedAsphalt.code)
            "
            [matTooltip]="'asphaltcode' | tt">
            <input
                class="row-input"
                autocomplete="off"
                formControlName="asphaltcode"
                placeholder="Asfaltcode"
                type="text" />
        </td>
        <td class="number-input">
            <input
                class="row-input"
                #tonsInput
                appDecimalInput
                autocomplete="off"
                formControlName="tons"
                placeholder="0"
                type="text" />
        </td>
        <td class="number-input">
            <input
                class="row-input"
                appDecimalInput
                autocomplete="off"
                formControlName="thickness"
                placeholder="0"
                type="text" />
        </td>
        <td class="tabletime one" [matTooltip]="'asphalt-trucks-time' | tt">
            <div class="timepicker">
                <mat-select formControlName="time" placeholder="Tijd" panelWidth="200px">
                    <mat-select-trigger>
                        <small>{{ planningAsphalt.time | date: 'EEE' }}</small>
                        {{ planningAsphalt.time | date: 'HH:mm' }}
                    </mat-select-trigger>
                    @for (day of timeList; track day) {
                        <mat-optgroup label="{{ day.datetime | date: 'EEEE d MMM' }}">
                            @for (time of day.options; track time) {
                                <mat-option [value]="time.time">
                                    {{ time.datetime | date: 'HH:mm' }}
                                    <small>{{ time.datetime | date: 'EEE d MMM' }}</small>
                                </mat-option>
                            }
                        </mat-optgroup>
                    }
                </mat-select>
            </div>
        </td>
        <td
            class="number-input"
            [class.warning]="+planning.trucks > availableTrucks - maxUsedTrucks + +planning.trucks"
            [matTooltip]="'trucks-count' | tt">
            @if (availableTrucks) {
                <div class="available-trucks">
                    {{ availableTrucks - maxUsedTrucks + (+planningAsphalt.trucks || 0) }}
                </div>
            }
            <input
                class="row-input"
                appDecimalInput
                autocomplete="off"
                formControlName="trucks"
                placeholder="0"
                type="text" />
        </td>
        <td class="text-input" [matTooltip]="planningAsphalt?.comment">
            <input
                class="row-input"
                autocomplete="off"
                formControlName="comment"
                maxlength="300"
                placeholder="Opmerking"
                type="text" />
        </td>
        @if (!formsDisabled) {
            <td>
                <button
                    class="icon-button-medium"
                    (click)="removeAsphaltPlanning()"
                    color="warn"
                    mat-icon-button
                    matTooltip="Verwijder"
                    matTooltipClass="warn-background"
                    matTooltipPosition="right"
                    tabindex="-1">
                    <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                </button>
            </td>
        }
    </ng-container>
}
